<template>
  <div class="p-2">
    <div class="cursor-pointer group">
      <div
        class="rounded-lg overflow-hidden thumb w-full h-[150px] bg-primary-800 flex justify-center items-center relative"
      >
        <img v-if="img" class="object-cover w-full h-full" :src="img" />
        <Network v-else class="size-8" />

        <div
          class="flex flex-col justify-between absolute left-0 top-0 right-0 bottom-0 bg-black/90 p-4 opacity-0 group-hover:opacity-100 transition-all duration-300"
        >
          <div>
            <p class="text-xs">{{ description }}</p>
            <p v-if="categories.length" class="italic text-secondary-600">
              in: {{ categories.join(',') }}
            </p>
          </div>
          <Button as="span" class="w-full">Create project</Button>
        </div>
      </div>
      <div class="w-full py-2">
        <div class="title text-neutral-300 font-semibold text-sm">
          {{ title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Network } from 'lucide-vue-next';
import { Button } from '@ui/components/button';

defineProps({
  title: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: null,
  },
  img: {
    type: String,
    default: null,
  },
  icon: {
    type: String,
    default: '',
  },
  categories: {
    type: Array,
    default: () => [],
  },
});
</script>
